const emailformDataFormatter = (data, formData) => {
  const dataSet = data?.items ? JSON.parse(JSON.stringify(data?.items)) : [];
  const emailData = dataSet.filter((ele) => ele.id === formData["email_id"])[0];
  if (emailData) {
    formData["placeholder_email"] = emailData["email_address"];
  }
  return formData;
};

export default emailformDataFormatter;
